module.exports = __webpack_public_path__ + "static/img/199_TO8_2102_og.4f626d7.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/199_TO8_2102_og.jpg
// module id = XBWv
// module chunks = 0